// @ts-nocheck
/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { FC } from "react";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
/* Starter Custom Code - End */

interface OwnProps {
    title: string;
    quoteId: string;
}

type Props = OwnProps;

const RfqQuoteDetailsPageTypeLink: FC<Props> = ({ title, quoteId }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: "RfqQuoteDetailsPage",
            overrideTitle: title,
            queryString: `quoteId=${quoteId}`,
            linkAccessibleText: translate("See Quote Details"), // Starter Custom Code
        },
    });
};

export default RfqQuoteDetailsPageTypeLink;
